import React, { useEffect, useRef, useState } from 'react'
import { Row, Col, message, Button, Card, Table, Modal, Input } from 'antd';
import { useMyContext } from 'Context/MyContextProvider';
import apiClient from 'services/apiClient';
import EmailTemplateModal from './modal/EmailTemplateModal';
import { EyeOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import Flex from 'components/shared-components/Flex';
import { Link } from 'react-router-dom';
const EmailTemplate = () => {
    const { api, authToken, UserData } = useMyContext();
    const [editData, setEditData] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [previewData, setPreviewData] = useState(null);
    const [searchText, setSearchText] = useState('');
    const searchInput = useRef(null);

    const fetchTemplates = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get(`${api}email-templates/${UserData.id}`, {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            });
            const data = (response.data.templates).reverse();
            setTemplates(data);
        } catch (error) {
            message.error('Failed to fetch templates');
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    const filteredTemplates = templates.filter(template => {
        const search = searchText.toLowerCase();
        return (
            template.template_id?.toLowerCase().includes(search) ||
            template.subject?.toLowerCase().includes(search) ||
            template.created_at?.toLowerCase().includes(search)
        );
    });

    const tableColumns = [
        {
            title: 'Template Name',
            dataIndex: 'template_id',
            sorter: (a, b) => a.template_id.localeCompare(b.template_id),
        },
        {
            title: 'Subject',
            dataIndex: 'subject',
            sorter: (a, b) => a.subject.localeCompare(b.subject),
        },
        {
            title: 'Date',
            dataIndex: 'created_at',
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            render: (created_at) => {
                const date = new Date(created_at);
                const day = ("0" + date.getDate()).slice(-2);
                const month = ("0" + (date.getMonth() + 1)).slice(-2);
                const year = date.getFullYear();
                let hours = date.getHours();
                const minutes = ("0" + date.getMinutes()).slice(-2);
                const seconds = ("0" + date.getSeconds()).slice(-2);
                let ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12;
                const formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;
                return `${day}/${month}/${year} | ${formattedTime}`;
            },
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            render: (_, item) => (
                <Flex alignItems="center" style={{ gap: '1rem' }}>
                    <Link onClick={() => handlePreview(item)} className='d-flex h4'>
                        <EyeOutlined />
                    </Link>
                    <Link onClick={() => handleEdit(item)} className='d-flex h4'>
                        <EditOutlined />
                    </Link>
                    <span className='d-flex h4 cursor-pointer' onClick={() => handleDelete(item)}>
                        <DeleteOutlined />
                    </span>
                </Flex>
            )
        }
    ];

    const handleEdit = (data) => {
        setEditData(data);
        setModalVisible(true);
    };
    const handleCreate = () => {
        setEditData(null);
        setModalVisible(true);
    };
    const handleModalCancel = () => {
        setModalVisible(false);
    };
    const handleModalSuccess = () => {
        fetchTemplates();
    };
    const handleDelete = async (item) => {
        try {
            const response = await apiClient.delete(`${api}email-templates/${item.id}`, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            if (response.data.status) {
                message.success('Email template deleted successfully');
                fetchTemplates();
            } else {
                message.error('Failed to delete email template');
            }
        } catch (error) {
            message.error('Error deleting the email template');
        }
    };
    const handlePreview = (item) => {
        setPreviewData(item);
    };
    const handlePreviewClose = () => {
        setPreviewData(null);
    };

    return (
        <Row gutter={24}>
            <EmailTemplateModal
                visible={modalVisible}
                onCancel={handleModalCancel}
                onSuccess={handleModalSuccess}
                api={api}
                authToken={authToken}
                UserData={UserData}
                editData={editData}
            />
            <Col xs={24}>
                <Card title="Email Templates" extra={
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Input.Search
                            allowClear
                            placeholder="Search templates..."
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                            style={{ width: 220 }}
                        />
                        <Button type="primary" onClick={handleCreate}>New</Button>
                    </div>
                }>
                    <div className="table-responsive">
                        <Table
                            pagination={{ pageSize: 10 }}
                            loading={loading}
                            columns={tableColumns}
                            dataSource={filteredTemplates}
                            rowKey='id'
                        />
                    </div>
                </Card>
            </Col>
            {/* Preview Modal */}
            {previewData && (
                <Modal
                    open={!!previewData}
                    onCancel={handlePreviewClose}
                    footer={null}
                    title={previewData.subject}
                    width={600}
                    style={{ top: 20 }}
                    destroyOnClose
                >
                    <div dangerouslySetInnerHTML={{ __html: previewData.body }} />
                </Modal>
            )}
        </Row>
    );
}

export default EmailTemplate
